import { render } from "./DeliveryForm.vue?vue&type=template&id=643ec7f2&scoped=true"
import script from "./DeliveryForm.vue?vue&type=script&lang=js"
export * from "./DeliveryForm.vue?vue&type=script&lang=js"

import "./DeliveryForm.vue?vue&type=style&index=0&id=643ec7f2&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-643ec7f2"

export default script